export { AvisCookies as default } from '@portal-internet/components';
